// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ui-confirm__message{font-size:.9375rem;white-space:normal}.ui-confirm .ui-modal__header{padding-top:1rem}.ui-confirm__footer{display:flex;justify-content:space-between;min-width:100%;padding-left:60px;padding-right:60px}.ui-confirm .ui-modal__footer{height:auto;padding:25px 0 60px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
